import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'
import withStyles from 'react-jss'

import { isEmpty } from '@elo-kit/utils/validators.utils'
import { getBackgroundImageCss } from '@elo-kit/utils/themes.utils'

import { EMPTY_TEXT_EDITOR } from 'constants/courses.constants'
import { QUIZ_ATTEMPT_STATUSES } from 'constants/quiz.constants'
import { EloOrCustomButton } from 'utils/themes.utils'

import quizAttemptStyles from './quizAttempt.styles'

@observer
class QuizAttempt extends Component {
  render() {
    const { courseViewsStore, quizzesStore, classes, defaultTheme } = this.props
    const { handleRetakeQuiz, seller = {}, toggleQuizResults } = courseViewsStore
    const { item: quiz } = quizzesStore

    const quizAvailable = !isEmpty(quiz)
    const { avatarUrl, publicName, fullName } = seller

    const {
      afterword,
      afterCompletetionTextEnabled,
      autoChecked,
      canBeRetaken,
      failureAfterword,
      pointsToPass,
      successAfterword,
      quizAttempts,
    } = quizAvailable ? quiz : {}
    const quizAttemptsLength = quizAttempts && quizAttempts.length
    // Get last attempt(saved as first on a server)
    const quizAttempt = !!quizAttemptsLength && quizAttempts[0]

    // For some reason Froala text editor send br even for empty comment
    const froalaCommentIsNotEmpty = quizAttempt && quizAttempt.submitComment !== EMPTY_TEXT_EDITOR
    const attemptInfoClasses = classNames('attempt-info', classes.attemptInfo)
    const attemptStatusClasses = classNames(classes.attemptStatus)

    const AfterCompletionText = ({ content }) =>
      content && (
        <div className='quiz-afterword fr-view white-widget'>
          <div className='round-image-36' style={{ backgroundImage: getBackgroundImageCss(avatarUrl) }} />
          <div className='author-comment'>
            <span className='author'>{publicName || fullName}</span>
            <span className='comment' dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      )

    const failedButtonProps = {
      orange: defaultTheme,
      onClick: canBeRetaken ? handleRetakeQuiz : toggleQuizResults,
      children: canBeRetaken ? I18n.t('react.payer.quiz.restartQuiz') : I18n.t('react.payer.common.seeResults'),
    }
    const seeResultsButtonProps = {
      orange: defaultTheme,
      onClick: toggleQuizResults,
      children: I18n.t('react.payer.common.seeResults'),
    }

    return (
      <Fragment>
        {quizAttempt && quizAttempt.status === QUIZ_ATTEMPT_STATUSES.waiting && (
          <Fragment>
            <div className='quiz-attempt waiting white-widget'>
              <div className={attemptInfoClasses}>
                <i className='fas fa-question-circle' />
                <span className={attemptStatusClasses}>{I18n.t('react.payer.quiz.waitingReview')}</span>
              </div>
            </div>

            {afterCompletetionTextEnabled && <AfterCompletionText content={afterword} />}
          </Fragment>
        )}

        {quizAttempt && quizAttempt.status === QUIZ_ATTEMPT_STATUSES.failed && (
          <Fragment>
            <div className='quiz-attempt failed white-widget'>
              <div className={attemptInfoClasses}>
                <i className='fas fa-frown' />
                <span className={attemptStatusClasses}>{I18n.t('react.payer.quiz.quizFailed')}</span>
              </div>
              <div className='attempt-actions'>
                <EloOrCustomButton defaultTheme={defaultTheme} {...failedButtonProps} />
                {autoChecked && (
                  <div className='points'>
                    <span className='gained'>{quizAttempt.gainedPoints > 0 ? quizAttempt.gainedPoints : 0}</span>/
                    <span className='all'>{pointsToPass}</span>
                  </div>
                )}
              </div>
            </div>

            {quizAttempt.submitComment && froalaCommentIsNotEmpty && (
              <div className='quiz-afterword fr-view white-widget'>
                <div className='round-image-36' style={{ backgroundImage: getBackgroundImageCss(avatarUrl) }} />
                <div className='author-comment'>
                  <span className='author'>{publicName || fullName}</span>
                  <span className='comment' dangerouslySetInnerHTML={{ __html: quizAttempt.submitComment }} />
                </div>
              </div>
            )}

            <AfterCompletionText content={failureAfterword} />
          </Fragment>
        )}

        {quizAttempt && quizAttempt.status === QUIZ_ATTEMPT_STATUSES.completed && (
          <Fragment>
            <div className='quiz-attempt completed white-widget'>
              <div className={attemptInfoClasses}>
                <i className='fas fa-smile' />
                <span className={attemptStatusClasses}>{I18n.t('react.payer.quiz.quizCompleted')}</span>
              </div>

              <div className='attempt-actions'>
                <EloOrCustomButton defaultTheme={defaultTheme} {...seeResultsButtonProps} />
                {autoChecked && (
                  <div className='points'>
                    <span className='gained'>{quizAttempt.gainedPoints}</span>/
                    <span className='all'>{pointsToPass}</span>
                  </div>
                )}
              </div>
            </div>

            {quizAttempt.submitComment && froalaCommentIsNotEmpty && !autoChecked && (
              <div className='quiz-afterword fr-view comment white-widget'>
                <div className='round-image-36' style={{ backgroundImage: getBackgroundImageCss(avatarUrl) }} />
                <div className='author-comment'>
                  <span className='author'>{publicName || fullName}</span>
                  <span className='comment' dangerouslySetInnerHTML={{ __html: quizAttempt.submitComment }} />
                </div>
              </div>
            )}

            {autoChecked && <AfterCompletionText content={successAfterword} />}
          </Fragment>
        )}
      </Fragment>
    )
  }
}

QuizAttempt.displayName = 'QuizAttempt'

export default withStyles(quizAttemptStyles)(QuizAttempt)
